
<div *ngIf="isMobile" id="appContent">
<app-front-page></app-front-page>
<app-count-down></app-count-down>
<app-phrase></app-phrase>
<app-places></app-places>
<app-gift></app-gift>
<app-message></app-message>
<app-greeting></app-greeting>
</div>
  
  <div *ngIf="!isMobile" id="warningMessage">
    <div id="text">
        Para una mejor experiencia, utiliza esta aplicación en dispositivos móviles en orientación vertical.
    </div>
    
  </div>